import { fetchData } from "./fetch";

export const updateMessage = ({ id, data }) => fetchData('PUT', `/conversations/${id}`, data);

export const sendMessage = ({ id, data }) => fetchData('PUT', `/conversations/${id}/message`, data);

export const sendOutgoingMessage = ({ id, data }) => fetchData('PUT', `/conversations/${id}/message/outgoing`, data);

export const classificateMessage = ({ id, data }) => fetchData('POST', `/conversations/${id}/message/classificate`, data);

export const sendEmail = ({ id, data }) => fetchData('POST', `/conversations/${id}/send-email`, data);

export const pauseConversation = ({ id }) => fetchData('POST', `/conversations/${id}/pause`);

export const resumeConversation = ({ id }) => fetchData('POST', `/conversations/${id}/resume`);
